import { ChatMessage, ChatMessageType } from './WSCommunicationTypes';
import { Paper } from '@mui/material';
import { ReactNode } from 'react';
import MultiLineTypography from './MultiLineTypography';

type ChatMessageProps = {
	msg: ChatMessage;
	onClick?: (msg: ChatMessage) => void;
	expand?: boolean;
};

export default function ChatMessageDisplay({
	msg,
	onClick,
	expand
}: ChatMessageProps) {
	let content: ReactNode | null = null;
	let background = '#D2D5FB';

	switch (msg.t) {
		case ChatMessageType.ServerError:
			content = <MultiLineTypography text={msg.msg} />;
			background = '#F48585';
			break;
		case ChatMessageType.UserError:
			content = <MultiLineTypography text={msg.msg} />;
			background = '#F48585';
			break;
		case ChatMessageType.NewSelector:
			content = (
				<MultiLineTypography
					text={`${msg.msg.key} → ${msg.msg.value}`}
				/>
			);
			background = '#FBDCD2';
			break;
		case ChatMessageType.AIMessage:
			content = (
				<MultiLineTypography
					text={msg.msg}
				/>
			);
			break;
		case ChatMessageType.ToolCall:
			content = (
				<MultiLineTypography
					sx={{
						fontFamily: !!msg.toolName.match(/^run_.*test.*/)
							? 'monospace'
							: undefined
					}}
					text={`${msg.toolName}(${JSON.stringify(msg.arguments, undefined, 1).replaceAll('\n', ' ')}) = ${msg.output}`}
				/>
			);
			background = '#D2FBEA';
			if (msg.toolName === 'no_product_in_html') {
				background = '#F48585';
			}
			break;
		case ChatMessageType.UserMessage:
			content = (
				<MultiLineTypography
					text={msg.msg}
				/>
			);
			background = '#C1E2B8';
			break;
	}

	return (
		<Paper
			elevation={1}
			sx={{
				background,
				color: '#000000',
				p: 1,
				display: 'block',
				boxSizing: 'border-box',
				maxWidth: expand === true ? 'calc(100vw - 64px)' : '100%',
				width: 'fit-content',
				minWidth: 0,
				overflow: 'hidden',
				overflowWrap: 'anywhere'
			}}
			onClick={() => onClick && onClick(msg)}
		>
			{content}
		</Paper>
	);
}
